import { useLocation } from "react-router-dom";
import { useAuth } from "@/auth";
import { useI18n } from "@/i18n";
import { Pin } from "lucide-react";

export default function MenuBacklinks() {
  const { user } = useAuth();
  const loc = useLocation();
  const { t } = useI18n();
  const cur = loc.pathname + loc.search;
  const hits = [];
  (user?.custom_menu || []).forEach((s) => (s.items || []).forEach((it) => {
    if (it.to === cur || (!loc.search && it.to === loc.pathname)) hits.push({ section: s.title, label: it.label });
  }));
  if (!hits.length) return null;
  return (
    <div className="px-4 md:px-8 pt-3 flex flex-wrap gap-2" data-testid="menu-backlinks">
      {hits.map((h, i) => (
        <span key={i} className="pill bg-[#C5A880]/20 text-[#8a6d3b] text-[11px] inline-flex items-center gap-1 font-semibold" data-testid={`menu-backlink-${i}`}>
          <Pin className="w-3 h-3" /> {t("cmLinkedFrom")}: {h.section} › {h.label}
        </span>
      ))}
    </div>
  );
}
